import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, DropdownButton, Dropdown, Button } from "react-bootstrap";
import {  resonateExclusiveFilter, shopOnlineFilter } from "../../../redux/action";
import { ONLINE_CATEGORIES, RESONATE_EXCLUSIVE_CATEGORIES } from "../../../constants/Constants";

require("./Categories.scss");

class Categories extends Component {

  handleResonateExclusiveFilter(filterName) {
    const path = window.location.pathname;
    path.endsWith("shop-online")? this.props.shopOnlineFilter(filterName): this.props.resonateExclusiveFilter(filterName);
  }
  render() {
    const categoryName = this.props.categoryName;
    const CATEGORIES = (window.location.pathname).endsWith("shop-online")? ONLINE_CATEGORIES: RESONATE_EXCLUSIVE_CATEGORIES;
    return (
      <Container className="categories-container">
        <div className="categories-navigation">
          {Object.keys(CATEGORIES).map(key => (
            <Button key={key} className="category-navigation-button" onClick={() => {
              this.handleResonateExclusiveFilter(CATEGORIES[key]);
            }}>
              {CATEGORIES[key]}
            </Button>
          ))}
        </div>
        <DropdownButton
          className="categories-dropdown"
          title={categoryName ? categoryName : "Select Category"}
        >
          {Object.keys(CATEGORIES).map(key => (
            <Dropdown.Item key={key} onClick={() => {
              this.handleResonateExclusiveFilter(CATEGORIES[key]);
            }}>
              {CATEGORIES[key]}
            </Dropdown.Item>
          ))}
        </DropdownButton>
      </Container>
    );
  }
}


const mapDispatchToProps = dispatch => {
  return {
    resonateExclusiveFilter: filterName => {
      dispatch(resonateExclusiveFilter(filterName));
    },
    shopOnlineFilter: filterName => {
      dispatch(shopOnlineFilter(filterName));
    }
  };
};

export default connect(null, mapDispatchToProps, null, {
  pure: false
})(Categories);
